import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  notificationConfigSchema,
  notificationConfigListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/notificationConfigs/actions';
import { NotificationConfigsActionTypes as types } from 'app/ducks/notificationConfigs/types';

function* createNotificationConfigSaga(action): any {
  yield put(sagaActions.createNotificationConfigPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).notificationConfigs.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, notificationConfigSchema);
    history.push(`/competitions/${action.payload.competition.id}`);
    yield put(sagaActions.createNotificationConfigSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createNotificationConfigFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateNotificationConfigSaga(action): any {
  yield put(sagaActions.updateNotificationConfigPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).notificationConfigs.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, notificationConfigSchema);

    yield put(sagaActions.updateNotificationConfigSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateNotificationConfigFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getNotificationConfigSaga(action): any {
  yield put(sagaActions.getNotificationConfigPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).notificationConfigs.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, notificationConfigSchema);
    yield put(sagaActions.getNotificationConfigSuccess(normalizedResponse));
    return normalizedResponse.entities.notificationConfigs[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getNotificationConfigFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllNotificationConfigsSaga(action): any {
  yield put(
    sagaActions.getAllNotificationConfigsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.notificationConfigs.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).notificationConfigs.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      notificationConfigListSchema,
    );

    yield put(
      sagaActions.getAllNotificationConfigsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllNotificationConfigsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createNotificationConfigSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_NOTIFICATION_CONFIG_REQUESTED,
    createNotificationConfigSaga,
  );
}

function* updateNotificationConfigSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_NOTIFICATION_CONFIG_REQUESTED,
    updateNotificationConfigSaga,
  );
}

function* getNotificationConfigSagaWatcher(): any {
  yield takeLatest(
    types.GET_NOTIFICATION_CONFIG_REQUESTED,
    getNotificationConfigSaga,
  );
}

function* getAllNotificationConfigsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_NOTIFICATION_CONFIGS_REQUESTED,
    getAllNotificationConfigsSaga,
  );
}

export default function* root(): any {
  yield all([
    createNotificationConfigSagaWatcher(),
    updateNotificationConfigSagaWatcher(),
    getNotificationConfigSagaWatcher(),
    getAllNotificationConfigsSagaWatcher(),
  ]);
}
